import AppShell from "@/components/layouts/AppShell";

/**
 * VenuesShell — layout persistente do módulo "Locais"
 * (/venues, /events, /venue/:id, /venue/:id/checkin).
 *
 * A BottomNav é montada uma única vez fora do <Outlet />: permanece fixa no
 * rodapé durante rolagem e navegação interna, sem piscar nem ser recriada.
 * As páginas já aplicam seu próprio `pb-24`, então o shell reserva apenas a
 * safe-area inferior do dispositivo.
 */
export default function VenuesShell() {
  return <AppShell reserveBottomSpace={false} />;
}
